import { IconContent } from '@icons';

export const plus: IconContent = {
    sm: '<path d="M8.5 3h-1v4.5H3v1h4.5V13h1V8.5H13v-1H8.5V3Z" />',
    lg: '<path d="M15.75 17.25v8.25h1.5v-8.25h8.25v-1.5h-8.25V7.5h-1.5v8.25H7.5v1.5h8.25Z" />',
};
